'use client';

import SkinSeoulSelectsSection from '@/containers/home/sections/SkinSeoulSelectsSection/SkinSeoulSelectsSection';
import { ProductStockStatus, RECENTLY_VIEWED_PRODUCTS_KEY, useProductService, useRegionCurrency } from '@skin-seoul/service';
import { QueryBoundary } from '@/components/ui/QueryBoundary';
import { RecentlyViewedList } from '@/containers/home/sections/RecentlyViewedSection/RecentlyViewedList';
import RecentlyViewedListSkeleton from '@/containers/home/sections/RecentlyViewedSection/RecentlyViewedListSkeleton';
import Cookies from 'js-cookie';
import SectionContainer from '../../components/SectionContainer';
const ProductRecentlyViewedSection = () => {
  const rawRecentlyViewed = Cookies.get(RECENTLY_VIEWED_PRODUCTS_KEY);
  const recentlyViewedIds = rawRecentlyViewed?.split('|').filter(Boolean) || [];
  if (!rawRecentlyViewed || recentlyViewedIds.length === 0) {
    Cookies.remove(RECENTLY_VIEWED_PRODUCTS_KEY);
  }
  const {
    currency
  } = useRegionCurrency();
  const {
    useGetSuspenseProductsByIds: useGetProductsByIds
  } = useProductService();
  const {
    data: recentlyViewedData
  } = useGetProductsByIds({
    ids: recentlyViewedIds.join(','),
    currency
  });
  const filteredRecentlyViewedProducts = recentlyViewedData?.filter(product => product.status === ProductStockStatus.instock);
  if (!filteredRecentlyViewedProducts || filteredRecentlyViewedProducts.length === 0) {
    Cookies.remove(RECENTLY_VIEWED_PRODUCTS_KEY);
    return <SkinSeoulSelectsSection />;
  }
  return <SectionContainer headerTitle="Recently Viewed" data-sentry-element="SectionContainer" data-sentry-component="ProductRecentlyViewedSection" data-sentry-source-file="ProductRecentlyViewedSection.tsx">
      <QueryBoundary clientOnly loadingFallback={<RecentlyViewedListSkeleton length={4} />} data-sentry-element="QueryBoundary" data-sentry-source-file="ProductRecentlyViewedSection.tsx">
        <RecentlyViewedList recentlyViewedProducts={filteredRecentlyViewedProducts} data-sentry-element="RecentlyViewedList" data-sentry-source-file="ProductRecentlyViewedSection.tsx" />
      </QueryBoundary>
    </SectionContainer>;
};
export default ProductRecentlyViewedSection;